// @flow
import * as React from 'react'
import tw from 'tailwind-styled-components'

type Props = {
  children?: React.Node,
  gap?: 'none' | 'small' | 'regular' | 'large' | 'xlarge',
  cols: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12,
}

const Grid: React.ComponentType<Props> = tw.div`
  grid
  ${({ cols }: Props) => {
    if (cols === 0) {
      return 'grid-cols-none'
    }

    return `grid-cols-${cols}`
  }}

  ${({ gap }: Props) => {
    switch (gap) {
      case 'none':
        return 'gap-0'
      case 'small':
        return 'gap-2'
      case 'regular':
        return 'gap-4'
      case 'large':
        return 'gap-8'
      case 'xlarge':
        return 'gap-16'
      default:
        return 'gap-4'
    }
  }}
`

export default Grid
